import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  Renderer2,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { Socks } from 'src/app/model/out-fit';
import { ValidationErrorKey, ValidationResult } from 'src/app/validations/customization/customization.validation';

@Component({
  selector: 'app-customize-socks',
  templateUrl: './customize-socks.component.html',
  styleUrls: ['./customize-socks.component.css'],
})
export class CustomizeSocksComponent {
  @Input() colors!: string[];
  @Input() socksSelections!: Socks;

  @Input() validationResult: ValidationResult | null = null;


  @ViewChild('svgContainer') svgContainer!: ElementRef;
  @Output() socksSelectionsChange: EventEmitter<any> = new EventEmitter<any>();
  constructor(private renderer: Renderer2) {}
  
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['socksSelections'] && this.svgContainer) {
      this.setTopColor(this.socksSelections.topColor);
      this.setBottomColor(this.socksSelections.bottomColor);
      this.setLogoColor(this.socksSelections.logoColor);
    }
  }

  hasError(key: ValidationErrorKey): boolean {
    return !!this.validationResult?.errorKeys.includes(key);
  }

  setTopColor(color: string) {
    this.socksSelections.topColor = color;

    this.socksSelectionsChange.emit({ part: 'topColor', value: color });

    const selectors = [
      'svg path[d^="M8.29988"]',
      'svg path[d^="M64.4243"]',
      'svg path[d^="M114.209"]',
      'svg path[d^="M170.333"]',
    ];
    selectors.forEach((selector) => {
      const paths = this.svgContainer?.nativeElement.querySelectorAll(selector);
      if (paths) {
        paths.forEach((el: Element) => {
          el.setAttribute('fill', color);
        });
        //path.renderer.setAttribute('fill', color);
      }
    });
  }

  setLogoColor(color: string) {
    this.socksSelections.logoColor = color;
    this.socksSelectionsChange.emit({ part: 'logoColor', value: color });

    const selectors = ['#logo'];

    selectors.forEach((selector) => {
      const paths = this.svgContainer?.nativeElement.querySelectorAll(selector);

      if (paths) {
        paths.forEach((el: Element) => {
          el.setAttribute('fill', color);
        });
      }
    });
  }

  setBottomColor(color: string) {
    this.socksSelections.bottomColor = color;

    this.socksSelectionsChange.emit({ part: 'bottomColor', value: color });

    const selectors = [
      'svg path[d^="M155.33"]',
      'svg path[d^="M201.433"]',
      'svg path[d^="M95.5239"]',
      'svg path[d^="M95.223"]',
    ];

    selectors.forEach((selector) => {
      const path = this.svgContainer?.nativeElement.querySelector(selector);
      if (path) {
        path.setAttribute('fill', color);
      }
    });
  }
}
